import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { trackPageView } from "./analytics";

export default function AnalyticsListener() {
  const location = useLocation();
  const { idFeira } = useParams();

  useEffect(() => {
    trackPageView(location.pathname + location.search, {
      feira_id: Number(idFeira) || 0,
    });
  }, [location.pathname, location.search, idFeira]);

  return null;
}